"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _ButtonLink = _interopRequireDefault(require("@kiwicom/orbit-components/lib/ButtonLink"));
var _MenuHamburger2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/MenuHamburger"));
var _Logo = _interopRequireWildcard(require("../../Logo"));
var _NavRightLinks = _interopRequireDefault(require("./NavRightLinks"));
var _context = require("../../../services/brand/context");
var _context2 = require("../../../services/intl/context");
var _HeaderLinks = _interopRequireDefault(require("../../HeaderLinks"));
var _context3 = require("../services/context");
var _jsxRuntime = require("react/jsx-runtime");
var _MenuHamburger;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Navbar = ({
  togglePanel,
  modalId,
  brandLanguage,
  onOpenHelp,
  onLogoClick,
  urlLogo,
  active
}) => {
  const brand = (0, _context.useBrand)();
  const {
    language
  } = (0, _context2.useIntl)();
  const {
    areHeaderLinksShown,
    isLogoShown,
    isSideNavShown
  } = (0, _context3.useNavConfig)();
  const parsedHomeRedirectUrl = brand.home_redirect_url.endsWith("/") ? `${brand.home_redirect_url}${language.id}/` : `${brand.home_redirect_url}/${language.id}/`;
  const logoRedirectUrl = urlLogo !== null && urlLogo !== void 0 ? urlLogo : parsedHomeRedirectUrl;
  const textWithSeparator = (() => {
    if (brand.powered_by_kiwi) {
      return _Logo.TextWithSeparatorOptions.POWERED_BY_KIWI;
    }
    return undefined;
  })();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
    justify: "between",
    align: "center",
    spacing: "none",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
      inline: true,
      align: "center",
      grow: true,
      spacing: "medium",
      largeMobile: {
        spacing: "large"
      },
      children: [isLogoShown && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Logo.default, {
        redirectUrl: logoRedirectUrl,
        title: brand.name,
        id: brand.id,
        textWithSeparator: textWithSeparator,
        onClick: onLogoClick
      }), areHeaderLinksShown && /*#__PURE__*/(0, _jsxRuntime.jsx)(_HeaderLinks.default, {
        active: active
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
      inline: true,
      align: "center",
      justify: "end",
      spacing: "large",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_NavRightLinks.default, {
        modalId: modalId,
        brandLanguage: brandLanguage,
        onOpenHelp: onOpenHelp,
        togglePanel: togglePanel
      }), isSideNavShown && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonLink.default, {
        compact: true,
        ariaControls: "Open sidebar",
        rel: "nofollow",
        iconLeft: _MenuHamburger || (_MenuHamburger = /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuHamburger2.default, {})),
        title: "Open sidebar",
        type: "secondary",
        onClick: togglePanel,
        dataTest: "TopNav-SideNav-Open"
      })]
    })]
  });
};
var _default = Navbar;
exports.default = _default;